import { MessageDescriptor, useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics';
import { useDeviceState } from '@/hooks/store';
import genericMessages from '@/messages/messages';
import { CALM_ONE_LINKS } from '@/utils/deeplinks/deeplinks';

import { StyledButton } from './styles';

const SuccessButton = ({
	successCTAUrl,
	partnerMessages,
}: {
	successCTAUrl: string | undefined;
	partnerMessages?: {
		injectPartnerName?: boolean;
		headline?: MessageDescriptor | null;
		subheadline?: MessageDescriptor | null;
		activate?: MessageDescriptor | string | null;
		instructions?: MessageDescriptor | null;
		help?: MessageDescriptor | null;
		legal?: MessageDescriptor | null;
		error?: MessageDescriptor | null;
		successText?: MessageDescriptor | null;
		successCTA?: MessageDescriptor | null;
		requestAccess?: MessageDescriptor | null;
		errorRequestAccess?: MessageDescriptor | null;
	};
}) => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();
	const device = useDeviceState();

	function onCtaClick(): void {
		const url = successCTAUrl ?? CALM_ONE_LINKS.app;

		logEvent({
			eventName: 'Success : CTA : Clicked',
			eventProps: {
				url,
			},
		});
		window.location.assign(url);
	}

	function getCTAButtonLabel(): MessageDescriptor {
		if (partnerMessages?.successCTA) {
			return partnerMessages?.successCTA;
		}
		return device.isMobile ? genericMessages.downloadCalmApp : genericMessages.openCalmApp;
	}

	return (
		<StyledButton onPress={onCtaClick} role="link">
			{formatMessage(getCTAButtonLabel())}
		</StyledButton>
	);
};

export default SuccessButton;
